'use strict';

/**
 * Init scrolling position
 * @param {Selector} container slider container
 * @param {Selector} slider slider
 * @param {Selector} currentItem slider item
 */
function initScrollingPosition(container, slider, currentItem) {
    if (slider.length > 0) {
        slider.scrollLeft(currentItem.position().left - (container.width() / 2) + (currentItem.width() / 2));
    }
}

/**
 * Scroll Button event handler
 * @param {Event} event click event
 * @param {Selector} $slider slider
 */
function handleScrollButton(event, $slider) {
    var $target = $(event.currentTarget);

    var isLeftButton = $target.hasClass('left-btn');
    var currentPosition = $slider.scrollLeft();
    var stepSize = 200;

    if (isLeftButton) {
        $slider.scrollLeft(currentPosition - stepSize);
    } else {
        $slider.scrollLeft(currentPosition + stepSize);
    }
}

/**
* Handles smooth scrolling for a slider element when a navigation button is clicked.
*
* @param {Object} event - The event object triggered by the button click.
* @param {jQuery} $slider - The jQuery object representing the slider element to be scrolled.
*/
function handleSmoothScrollButton(event, $slider) {
    var $target = $(event.currentTarget);
    var isLeftButton = $target.hasClass('left-btn');
    var currentPosition = $slider.scrollLeft();
    var stepSize = currentPosition + (isLeftButton ? -200 : 200);

    $slider.animate({ scrollLeft: stepSize }, 500);
}

module.exports = {
    initScrollingPosition: initScrollingPosition,
    handleScrollButton: handleScrollButton,
    handleSmoothScrollButton: handleSmoothScrollButton
};
